export default "__VITE_ASSET__CH4Dp7gF__"